import React, { useState } from 'react'
import ReactPlayer from 'react-player'

const VideoModal = () => {
  const [isOpen, setOpen] = useState(false)

  return (
    <React.Fragment>
      {isOpen && (
        <div className="video-modal-overlay" onClick={() => setOpen(false)}>
          <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="video-modal-close" onClick={() => setOpen(false)}>
              <i className="ti-close"></i>
            </button>
            <ReactPlayer
              url="https://www.youtube.com/watch?v=74DWwSxsVSs"
              playing
              controls
              width="100%"
              height="100%"
            />
          </div>
        </div>
      )}

      <div className="video-btn" onClick={() => setOpen(true)}>
        <i className="flaticon-play"></i>
      </div>
    </React.Fragment>
  )
}

export default VideoModal